export default __webpack_public_path__ + "static/media/selectedCircle.b3d172a7.svg";